"use client";

import { ReactNode } from "react";
import styles from "../../Home.module.css";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <main className={styles.container}>
      <div className={styles.topLeftGradient}></div>
      <div className={styles.topRightGradient}></div>
      <div className={styles.bottomGradient}></div>

      {children}
    </main>
  );
}
